// extracted by mini-css-extract-plugin
module.exports = {"somethingWentWrong":"Webforms_somethingWentWrong__3ns2s"};